import React, { Fragment } from "react"
import { ToggleOption } from "bootstrap-micro"
import { Row } from "../../DataTable.jsx";


export const RS485Module = ({ module }) => {

    const enabled = module.settings.enabled != "DISABLED";
    return <Fragment>
        <Row label="Address"> <input type="number" step="1" min="0" max="64" className="form-control" value={ module.settings.address } /></Row>
        <Row label="Enabled" noParagraph 
        > 
            <ToggleOption disabled={true} value={enabled} />
        </Row>
    </Fragment>
}